module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fb-Gd-Hc-Ia.5c103be9.png";